// extracted by mini-css-extract-plugin
export default {"container":"RJ-z","timeTop":"SJ-z","timeCountdown":"TJ-z","cta":"UJ-z","disabled":"VJ-z","product":"WJ-z"};